export const locale = {
    lang: 'nl',
    data: {
      'FILEMANAGER': {
        'TITULO': 'Bestandsbeheerder',
        'SUBTI': 'Upload uw bedrijfsrelevante bestanden',
        'GPTW': {
          'TITULO': 'Klik op een bedrijfsnaam om de lijst met geüploade bestanden te tonen',
          'NUMMEREN': 'Aantal geüploade bestanden: '
        },
        'CT_NAME':'Collaborators who had severe traumatic event',
        'LABEL01':' Work Centers',
        'CARGA': {
          'TITULO': 'Klik hier om een bestand te uploaden of sleep het hierheen',
          'CARGANDOTIT': 'Uploaden',
          'CARGANTOTXT': 'Het bestand wordt naar de databank gestuurd. Wacht even, alstublieft.',
        },
        'MENU': {
          'BOTON': 'Nieuw',
          'ARCHIVO': 'Bestand',
          'FOLDER': 'Map',
          'EXCELTI': 'Download Excel TI'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': 'Naam',
            'EXTEN': 'Uitbreiding',
            'FECHA': 'Upload datum',
            'ACCIES': 'Acties',
            'TAMANIO': 'Grootte'
          },
           // Temporales
          'TITULOSENC':{
            'NOMBRE': 'Naam van de medewerker: ',
            'ARCH': 'Bestandsnaam',
            'DATE': 'Actualiseringsdatum',
            'EXTEN': 'Werkplaatsnaam: ',
            'ACT': 'Acties',
            'BT': 'Thuis'
          },
          'TOOLTIP': {
            'DESCARGA': 'Download dit bestand',
            'DELETE': 'Verwijder dit bestand',
            'OPENFOLDER': 'Klik hier om deze map te openen',
            'VACIO': 'Deze map is leeg'
          }
        },
        'MENSAJES': {
          'CARGAOK': 'Het bestand is met succes opgeslagen',
          'CARGAREP': 'Het bestand is niet opgeslagen. Er bestaat al een bestand met dezelfde naam',
          'DELETERLY': 'Bevestigt u dat u dit bestand wilt verwijderen?',
          'DELETEOK': 'Het bestand is correct verwijderd',
          'CREATEFOLDER': 'Voer de naam van de nieuwe map in',
          'FOLDEROK': 'De map is met succes aangemaakt.',
          'archivo_save_4': 'De map kon niet worden aangemaakt. Er bestaat al een map met dezelfde naam Bevestig je dat je deze map moet verwijderen? Waarschuwing: De inhoud van deze map zal ook worden verwijderd',
          'DELETEFOLDEROK': 'De map en de inhoud ervan zijn met succes verwijderd',
          'INVALID_CHARS': 'De mapnaam mag alleen tekens van de letter A tot Z en cijfers bevatten',
          'BOTONES': {
            'SI': 'Ja',
            'NO': 'Nee',
            'ACEPTAR': 'Accepteren',
            'CREAR': 'Creëer',
            'CANCELAR': 'Annuleren'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'TI-informatie',
          'Información CA': 'CA-informatie',
          'Información General': 'Algemene informatie',
          'Comunicación NOM035': 'NOM035 Communicatie',
          'Listado de colaboradores NOM-035': 'NOM-035 Collaboratos List',
          'PDF de resultados NOM-035F': 'NOM-035 Resultaten PDF',
          'Plantilla listado colaboradores':'Collaborateurs lijst sjabloon',
          'Campaña de Comunicación 2020': 'Communicatiecampagne',
          // 'Culture Audit': 'Cultuuraudit',
          'Guía de certificación':'Certificeringsgids',
          'Listado de colaboradores': 'Lijst van medewerkers',
          'Plantillas': 'Sjablonen',
          'Templates con TI': 'Sjablonen met IT',
          'Templates Página' : 'Paginasjablonen',
          'Certificar' : 'Certificeren',
          'Focus Area': 'Focusgebied',
          'Medir' : 'Meting',
          'Pulsecheck' : 'Press Check',
          'Row Data': 'Rijgegevens',
          'Reports': 'Verslagen',

          'Campana de Comunicacion': 'communicatie campagne',
          'Culture Audit': 'Cultuur Audit™',
          'Great Book': 'Geweldig boek',
          'Cuestionarios': 'Vragenlijsten',
          'Pulse Check': 'Druk op Controleren',
          'Base de datos': 'Database',
          'Practicas For All': 'Stages voor iedereen',
          'Reporte de Resultados': 'Resultatenrapport',
          'Validacion': 'Geldigmaking',
        }
      }
    }
};
